$(document).on( 'scroll', function(){
    $('.navbar').addClass('bg-white'); 
    $('.navbar').find('.dropdown-menu li a').attr('style', 'color: white');
    $('.navbar').find('.dropdown-toggle').attr('style', 'color: black !important');
    
    $('.navbar').find('img').css('filter', 'invert(0)'); 
    $('.navbar').find('button').attr('style', 'color: black !important');
   
   });
   
   $(window).on('scroll', function() {
     var scrollTop = $(this).scrollTop();
   
     if (scrollTop <= 5) {
       $('.navbar').removeClass('bg-white'); 
       $('.navbar li a').removeAttr('style');
       $('.navbar').find('img').css('filter', 'invert(1)'); 
       $('.navbar').find('button').removeAttr('style');      
       $('.navbar').find('.dropdown-toggle').attr('style', 'color: white !important');
     }
   
   });